import './widget.scss';
import bedBread from '../../assets/img/icons/bed-bread.svg';
function Meals() {
  return (
    <div className="widget widget--grey">
      <img className="" src={bedBread} alt="Meal" />
      <p className="widget__title">The Salvation Army’s Bed &amp; Bread Program serves nearly</p>

      <div className="widget__split-box widget__split-box--no-border">
        <div>
          <p className="widget__stat">1.6M</p>
          <p className="widget__text">meals in a year</p>
        </div>
        <div>
          <p className="widget__stat">437</p>
          <p className="widget__text">meals per day</p>
        </div>
      </div>
    </div>
  );
}

export default Meals;
